module.exports = __webpack_public_path__ + "assets/img/home.5a2fcf67.jpg";